import { useAuth } from '../contexts/AuthContext';

export default function PendingApprovalPage() {
    const { logout } = useAuth();

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-600 to-indigo-800">
            <div className="max-w-md w-full mx-4">
                <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
                    <div className="text-6xl mb-6">⏳</div>

                    <h1 className="text-2xl font-bold text-gray-800 mb-4">
                        Account Pending Approval
                    </h1>

                    <p className="text-gray-600 mb-6">
                        Your account has been created and is waiting for admin approval.
                        You'll receive an email notification once your account is approved.
                    </p>

                    <div className="bg-purple-50 border border-purple-200 rounded-lg p-4 mb-6">
                        <div className="flex items-center justify-center gap-2 text-purple-700">
                            <span className="text-xl">📧</span>
                            <span className="text-sm font-medium">
                                Check your email for updates
                            </span>
                        </div>
                    </div>

                    <p className="text-sm text-gray-500 mb-6">
                        If you believe this is an error, please contact your company administrator.
                    </p>

                    <button
                        onClick={logout}
                        className="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-medium transition"
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </div>
    );
}
